import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  standalone: false
})
export class App implements OnInit, OnDestroy {
  protected title = 'WTV';
  loading = true;

  private readonly _destroying$ = new Subject<void>();

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Handle SSO initialization / existing session
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setActiveAccount();
        this.checkAndSetActiveAccount();
        this.loading = false;
      });

    // Listen for login success across tabs
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result: any) => {
        console.log('Login successful', result);

        if (result?.payload?.account) {
          this.msalService.instance.setActiveAccount(result.payload.account);
        }
      });
  }

  setActiveAccount(): void {
    const accounts = this.msalService.instance.getAllAccounts();

    if (accounts.length > 0) {
      // Set the first account as active for SSO
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  checkAndSetActiveAccount(): void {
    const accounts = this.msalService.instance.getAllAccounts();

    if (accounts.length === 0) {
      // Try SSO silent login
      this.authService.ssoSilent().subscribe((result) => {
        if (result) {
          console.log('SSO Silent login successful');
          this.msalService.instance.setActiveAccount(result.account);
        }
      });
    } else {
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}